<app-lms-modal-frame [title]="'Money Laundering Scorecard'" [pageHeadWidth]="400">
    <div modal-body>
        <form [formGroup]="addRiskScoreForm" novalidate>
            <table class="table table-striped table-light table-hover table-sm mb-3 w-100">
                <caption>Add Risk Score</caption>
                <tbody class="field-4column-label">
                    <tr>
                        <td>Parameter Type</td>
                        <td>
                                                        <mdb-select class="select table-control has-cell-control" formControlName="parameterType" required>
                                                            <mdb-option *ngFor="let pType of lstParameterTypes" [value]="pType.value">{{pType.parameterType}}</mdb-option>
                                                        </mdb-select>
                        </td>
                    </tr>
                    <tr>
                        <td>Description</td>
                        <td>
                            <input formControlName="description" placeholder="Description" required>
                        </td>
                    </tr>
                    <tr>
                        <td>Score</td>
                        <td>
                            <input formControlName="score" placeholder="Score"
                                (keypress)="($event.charCode >= 48 && $event.charCode < 58) || ($event.charCode >= 44 && $event.charCode < 45) || ($event.charCode >= 46 && $event.charCode < 47)"
                                required>
                        </td>
                    </tr>
                </tbody>
            </table>
        </form>
    </div>

    <div modal-actions class="lms-action-bar">
        <button class="btn btn-primary me-2" mdbRipple (click)="close()">Close</button>
        <button class="btn btn-primary" mdbRipple (click)="saveRiskScore()">Save</button>
    </div>
</app-lms-modal-frame>
